module.exports = __webpack_public_path__ + "static/media/ios-notifications-off.6a06cfa6.svg";